import { useMemo } from 'react';
import { Box, CircularProgress, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';

import { LoginForm } from '@occc-app/Login/components/LoginForm';
import { LoginRequested } from '@occc-app/Login/components/LoginRequested';
import { MagicLinkRequestInput } from '@occc/graphql';

import logo from './images/oc-logo.svg';
import background from './images/login-background.png';

type LoginProps = {
  isLoading?: boolean;
  isMagicLinkRequested: boolean;
  submitForm: () => void;
  onGoBack: () => void;
  onFormSubmit: (input: MagicLinkRequestInput) => void;
};

const Login = ({ isLoading, isMagicLinkRequested, onFormSubmit, onGoBack }: LoginProps) => {
  const currentStateBlock = useMemo(() => {
    if (isLoading) {
      return <CircularProgress size='15rem' sx={{ display: 'block', my: 0, mx: 'auto' }} />;
    }

    if (isMagicLinkRequested) {
      return <LoginRequested onGoBackClick={onGoBack} />;
    }

    return <LoginForm onFormSubmit={onFormSubmit} />;
  }, [isLoading, isMagicLinkRequested, onFormSubmit, onGoBack]);

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='center'
        position='absolute'
        top={0}
        bottom={0}
        right={0}
        left={0}
        sx={{
          backgroundImage: `url('${background}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
        component='main'
      >
        <Paper
          sx={{
            position: 'relative',
            width: '448px',
            p: 3,
          }}
        >
          <Box
            component='img'
            display='block'
            mx='auto'
            my={5}
            src={logo}
            alt='PAR Retail Command Center'
          />
          {currentStateBlock}
        </Paper>
      </Box>
    </>
  );
};

export default Login;
